import React from "react";
// import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="font-titleFont flex h-full w-full max-w-full flex-1 transform overflow-hidden pb-7 pt-20 font-thin transition-all">
      <div className="mt-4 flex flex-1 flex-row items-center justify-center gap-4 px-6 py-4">
        <div className="container flex flex-col items-center justify-center px-5 lg:flex-row">
          <div className="mx-8 w-full lg:w-1/2">
            <div className="mb-8 text-center text-7xl font-extrabold">404!</div>
            <p className="mb-8 text-center text-2xl font-light leading-normal md:text-3xl">
              Lo siento no logramos encontrar la página.
            </p>
            <div className="flex w-full flex-row justify-center">
              {/* <Link
                                to='/'
                                className={`rounded-lg bg-error px-5 py-3 text-sm font-medium leading-5 text-app-secondary-text shadow-2xl transition-all hover:scale-105`}>
                                Ir a página principal
                            </Link> */}
            </div>
          </div>
          <div className="mx-5 my-12 w-full lg:flex lg:w-1/2 lg:justify-end">
            <img src="/assets/404_image.png" alt="Page not found" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
